import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../Structure/components/Head/Head';
import Footer from '../../Structure/components/Footer/Footer';
import AnimalFilter from './AnimalFilter/AnimalFilter';
import AnimalListContainer from './AnimalListContainer';
import {getAnimals, getAnimalsAvanzado, getInfoRaza} from '../actions/actionsAnimalList';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../Shared/components/Alerts/AlertsConteiner';
import WaitBlock from "../../Shared/components/Alerts/WaitBlock";
import {init, sendEmail} from "../../Shared/actions/actionsContactByEmail";
import {changeStepWaitBlock, showWaitBlock} from "../../Structure/actions/actionsStructure";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {ADS_TYPES, AdsManagerContainer} from "../../Ads/components/AdsManagerContainer";
import CardInfoRaza from "././CardInfoRazas/CardInfoRaza";

class AnimalListPage extends Component {

    constructor(props) {
        super(props);

        this.loadAnimals = this.loadAnimals.bind(this);
        this.EventWaitBlock = this.EventWaitBlock.bind(this);
    }

    showLoader() {
        if ($('#especie-filtro input:checked').attr('value') === "Perro") {
            $('#loaderImage img').attr("src", process.env.CDN_URL + "/images/adoptaunanimal/loader/dog.gif");
            // $('#loaderImage img').attr("src", getImageEncode("dog-loader"));
        } else {
            $('#loaderImage img').attr("src", process.env.CDN_URL + "/images/adoptaunanimal/loader/cat.gif");
            // $('#loaderImage img').attr("src", getImageEncode("cat-loader"));
        }
        $('#loaderImage').show();


        // var inputs = $(".progress-container").find($("label"));
        $('#div-space-buttom').show();
        $('#animals-list-container').css('visibility', 'hidden');
        //$('#animals-list-container').hide();

        /*for(let i =0 ; i< inputs.length; i ++)
        {
            let index = i + 1;
            let time = ((inputs.length) - i ) * 100;
            time = 0;
            $(".progress-container label:nth-child("+ index+")").css( "-webkit-animation", "anim 10s "+time+"ms infinite ease-in-out" );
            $(".progress-container label:nth-child("+index+")").css( "-animation", "anim 10s "+time+"ms infinite ease-in-out" );
        }*/

        // $('#loaderImage').removeClass('fadeOut').addClass('animated-400ms fadeIn');
    }

    loadAnimals(num) {
        let info = {
            pag: num,
            numPerRow: this.props.elementsPerRow,
            numPerPage: this.props.elementsPerPage,
            metadata: {
                polulateProtectora: true
            }
        };
        if (!this.props.avanzado) {
            this.props.getAnimals(info);
        } else {
            this.props.getAnimalsAvanzado(info);
        }
        if (this.props.filtersControl.especieSeleccionada && this.props.filtersControl.razaSeleccionada)
            this.props.getInfoRaza(this.props.filtersControl.especieSeleccionada, this.props.filtersControl.razaSeleccionada)

    }

    showFilter() {

    }


    EventWaitBlock(event) {
        if (event === "go") {
            this.props.sendEmail();
        } else {
            if (this.props.stepWaitBlock === 200 || this.props.stepWaitBlock === 201) {
                Alert.success('Enviado correctamente', {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-info-circle"
                    }
                });
                this.props.init(this.props.animalsControl);
            } else {
                Alert.error('Error: ' + this.props.errorWaitBlock, {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-exclamation-triangle"
                    }
                });
            }
            this.props.changeStepWaitBlock(0);
            this.props.changeWaitBlock(false);
        }
    }

    desnormalizeDataFilter(currentFilter, entities, totalRecords) {
        let currentEspecie = (currentFilter?.especieSeleccionada !== "ambos") ? currentFilter?.especieSeleccionada : "perros y gatos"
        let currentEspecieDesnorm
        if (currentEspecie) {
            if (currentEspecie === "perros y gatos") {
                currentEspecieDesnorm = currentEspecie
            } else {
                currentEspecieDesnorm = currentEspecie.charAt(0).toUpperCase() + currentEspecie.slice(1)
                currentEspecieDesnorm = (new RegExp("[aeiou]$").test(currentEspecieDesnorm)) ? currentEspecieDesnorm + "s" : currentEspecieDesnorm + "es"
            }
        }


        // let currentRazas = (currentFilter?.razasSeleccionadas[0] === "TODAS") ? [] : currentFilter?.razasSeleccionadas
        let currentRazas = (currentFilter?.razaSeleccionada === "TODAS") ? [] : currentFilter?.razaSeleccionada
        if (currentRazas) {
            currentRazas = currentFilter.razasAnimales[currentFilter.especieSeleccionada].find(r => r.value === currentRazas).label
        }
        // let currentRazaDesnorm = currentRazas
        //     .join(', ').replace(/,(?!.*,)/gmi, ' y');


        let currentSexo = (currentFilter?.sexoSeleccionado === "M") ? "macho" : (currentFilter?.sexoSeleccionado === "H") ? "hembra" : ""
        let currentSexoDesnorm
        if (currentSexo) {
            currentSexoDesnorm = (new RegExp("[aeiou]$").test(currentSexo)) ? currentSexo + "s" : currentSexo + "es"
        }

        const dataFilterNormaliced = {
            especie: currentEspecieDesnorm,
            raza: currentRazas,
            // raza: currentRazaDesnorm,
            sexo: currentSexoDesnorm,
        }

        return dataFilterNormaliced
    }


    formatTitleFromFilter(currentFilter, entities, totalRecords, dataFilterNormaliced) {

        let title = ""
        let especieRazaActivo = (dataFilterNormaliced.raza) ? dataFilterNormaliced.raza : dataFilterNormaliced.especie
        let especieSexoActivo = (dataFilterNormaliced.sexo) ? dataFilterNormaliced.sexo : ""

        title = "" + totalRecords + " " + especieRazaActivo + " " + especieSexoActivo + " en adopción"

        return title
    }


    render() {

        let dataFilterNormaliced = this.desnormalizeDataFilter(this.props.filtersControl, this.props.animals, this.props.totalRecord)
        let titlePage = this.formatTitleFromFilter(this.props.filtersControl, this.props.animals, this.props.totalRecord, dataFilterNormaliced)

        return (
            <div>
                <Head
                    previousPath={"adoptar"}
                />
                {this.props.showWaitBlock &&
                    <WaitBlock
                        message={"Espere por favor..."}
                        methodChange={this.EventWaitBlock}
                    />
                }
                <div id="animals-list" className="container main-content">
                    {/*<div>Ver {(this.props.totalRecordProtectora === 1)? this.props.totalRecordProtectora +" resultado": this.props.totalRecordProtectora +" resultados"}</div>*/}
                    <div className="cardInfoTitle">
                        <h1 className="">
                            {titlePage}
                            {/*esto es un title de la página*/}
                        </h1>
                    </div>
                    <div className="row">

                        <div id="" className="col-lg-2">
                            <AnimalFilter
                                loader={this.showLoader.bind(this)}
                                loadData={this.loadAnimals}
                                filterControl={"filtersControl"}
                                varsData={{}}
                            />
                            <AdsManagerContainer type={ADS_TYPES.SKYSCRAPER} onlyDesktop sticky/>
                        </div>

                        <div id="loaderImage">
                            <LazyLoadImage threshold={150} src=""/>
                            <div className="loaderImageText">B U S C A N D O . . .</div>
                        </div>
                        <div id="animals-list-container" className="col-lg-10">
                            <AnimalListContainer
                                list={this.props.animals}
                                loadAnimals={this.loadAnimals}
                                totalRecord={this.props.totalRecord}
                                pag={this.props.pag}
                                elementsPerRow={this.props.elementsPerRow}
                                elementsPerPage={this.props.elementsPerPage}
                                animalsControl={"animals"}
                                animalsControlDetail={"animalDetail"}
                                activeCards={
                                    {
                                        animal: true,
                                        imagenyvideo: true,
                                        protectora: true
                                    }
                                }
                                animalIdParam={this.props.params.id}
                                infoRaza={this.props.infoRaza}
                            />
                        </div>
                    </div>

                    <AdsManagerContainer type={ADS_TYPES.BILLBOARD}/>
                    <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>
                </div>
                <div id="div-space-buttom"></div>
                <Footer percent={100} configFooter={{"moreInfo": false}}
                />
            </div>
        );
    }

    componentWillMount() {
        var width = window.innerWidth;
        var info = {};
        if (width < 992) {
            info = {
                pag: 0,
                numPerRow: 2,
                numPerPage: 12
            };
        } else {
            info = {
                pag: 0,
                numPerRow: 3,
                numPerPage: 12,
                metadata: {
                    polulateProtectora: true
                }
            };
        }

        this.props.getAnimals(info);
        if (this.props.filtersControl.especieSeleccionada && this.props.filtersControl.razaSeleccionada)
            this.props.getInfoRaza(this.props.filtersControl.especieSeleccionada, this.props.filtersControl.razaSeleccionada)
        //Initial scroll
        let element = $("body");
        if (element.length !== 0) {
            //console.log("AnimalListPage::componentWillMount() -> Haciendo scrollTop");
            $('body,html').stop(true, true).animate({scrollTop: element.offset().top}, 0);
        }

        this.props.changeStepWaitBlock(0);
        this.props.changeWaitBlock(false);

    }

    componentDidMount() {

        var width = window.innerWidth;

        if (width < 992) {
            // $('.burger').removeClass('animated-500ms fadeOutLeft').addClass('animated-500ms fadeInLeft');
        }

        let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

        if (!this.props.showHead) {
            // $('.header-topbar').addClass('animated-0s fadeInDown').one(animationEnd, () => {
            //     $('.header-topbar').removeClass('animated-0s fadeInDown');
            // });
            //$('.header-topbar').css("visibility", "visible");
        } else {
            // $('.header-topbar').removeClass('animated-0s fadeInDown');
            //$('.header-topbar').css("visibility", "visible");
        }

        this.showLoader();


    }

    componentDidUpdate() {
        if (this.props.showWaitBlock) {
            $('#modal-container').removeClass('out').addClass("one");
            $('body').addClass('modal-active');
        } else {
            $('body').removeClass('modal-active');
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        animals: state.animals.list,
        totalRecord: state.animals.totalRecord,
        pag: state.animals.pag,
        elementsPerRow: state.animals.elementsPerRow,
        elementsPerPage: state.animals.elementsPerPage,
        avanzado: state.filtersControl.avanzado,
        showHead: state.structureControl.showHead,
        showWaitBlock: state.structureControl.showWaitBlock,
        stepWaitBlock: state.structureControl.stepWaitBlock,

        infoRaza: state.animals.infoRaza,
        filtersControl: state.filtersControl,

    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    getAnimals,
    getAnimalsAvanzado,
    getInfoRaza,
    sendEmail: sendEmail,
    changeWaitBlock: showWaitBlock,
    changeStepWaitBlock,
    init
})(AnimalListPage)
